import { ClickAwayListener, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";

import { useGetLink } from "../hooks/useGetLink";

// ----------------------------------------------------------------------

export const CopyIcon = () => {
	const [open, setOpen] = useState(false);

	const { link } = useGetLink();
	const { translate } = useLocales();

	const copyToClipboard = async () => {
		await navigator.clipboard.writeText(link);
		setOpen(true);
	};

	const handleTooltipClose = () => {
		setOpen(false);
	};

	return (
		<ClickAwayListener onClickAway={handleTooltipClose}>
			<Tooltip
				PopperProps={{
					disablePortal: true
				}}
				onClose={handleTooltipClose}
				open={open}
				disableFocusListener
				disableHoverListener
				disableTouchListener
				title={translate("app_secrets.copied")}
			>
				<IconButton onClick={copyToClipboard}>
					<Iconify icon='ph:copy' color='primary.dark' />
				</IconButton>
			</Tooltip>
		</ClickAwayListener>
	);
};

export default CopyIcon;
